/**
 * Pure scroll utility functions for Gantt chart
 */

export const SCROLL_CONFIG = {
	DEBOUNCE_MS: 150,
	THRESHOLD_PX: 200,
	RETRY_INTERVAL_MS: 500,
	MAX_RETRY_TIME_MS: 5000,
};

export const createScrollHandler = (onLoadMore, hasMorePages, loadingMore) => {
	return function() {
		const distanceFromBottom = 
			this.scrollHeight - this.scrollTop - this.clientHeight;

		if (
			distanceFromBottom < SCROLL_CONFIG.THRESHOLD_PX &&
			hasMorePages &&
			!loadingMore
		) {
			onLoadMore();
		}
	};
};

export const setupScrollListener = (
	container,
	onLoadMore,
	hasMorePages,
	loadingMore,
	retryCount = 0
) => {
	return new Promise((resolve) => {
		const maxRetries = Math.floor(
			SCROLL_CONFIG.MAX_RETRY_TIME_MS / SCROLL_CONFIG.RETRY_INTERVAL_MS
		);

		const actualScrollContainer = container.querySelector(".wx-chart");

		if (!actualScrollContainer) {
			if (retryCount < maxRetries) {
				setTimeout(() => {
					setupScrollListener(
						container,
						onLoadMore,
						hasMorePages,
						loadingMore,
						retryCount + 1
					).then(resolve);
				}, SCROLL_CONFIG.RETRY_INTERVAL_MS);
			} else {
				resolve(null);
			}
			return;
		}

		let debounceTimer = null;
		const handleScroll = () => {
			if (debounceTimer) {
				clearTimeout(debounceTimer);
			}

			debounceTimer = setTimeout(() => {
				const scrollTop = actualScrollContainer.scrollTop;
				const scrollHeight = actualScrollContainer.scrollHeight;
				const clientHeight = actualScrollContainer.clientHeight;
				const distanceFromBottom = scrollHeight - scrollTop - clientHeight;

				if (
					distanceFromBottom < SCROLL_CONFIG.THRESHOLD_PX &&
					hasMorePages &&
					!loadingMore
				) {
					onLoadMore();
				}
			}, SCROLL_CONFIG.DEBOUNCE_MS);
		};

		actualScrollContainer.addEventListener("scroll", handleScroll);

		const cleanup = () => {
			actualScrollContainer.removeEventListener("scroll", handleScroll);
			if (debounceTimer) clearTimeout(debounceTimer);
		};

		resolve(cleanup);
	});
};